@if (demo.isActive)
{
<div class="row mb-5">

  <div class="col-8 d-flex">
    <div class="card card flex-grow-1 mb-0">
      <div class="card-body d-flex flex-column">
        <p class="small fw-bold mb-3 oneline">{{ poolTexts.growth | localize }}</p>
        <div class="pool-chart">
          <canvas #poolChart class="chart-canvas"></canvas>
        </div>
      </div>
    </div>
  </div>

  <div class="col-4">
    <app-kpi-card class="h-auto mb-3" [label]="poolTexts.size | localize">
      {{ poolKpis.size | number }}
    </app-kpi-card>
    <app-kpi-card class="h-auto mb-3" [label]="poolTexts.switchSignals | localize">
      {{ poolKpis.switchSignals | number }}
    </app-kpi-card>
    <app-kpi-card class="h-auto" [label]="poolTexts.engagements | localize">
      {{ poolKpis.engagements | number }}
    </app-kpi-card>
  </div>

</div>
}

<div class="card mt-4">
    <div class="card-header">
        <h5 class="card-title">Aktivitäten</h5>
    </div>
    <div class="card-body card-body-list" *ngIf="!obfuscate">
        <sc-activity-feed [scAnchorTarget]="'Aktivitäten'" [user]="userService.me" [uri]="activitiesUri"
            [readOnly]="true" [condensed]="false" (navigate)="navigate($event)">
            <ng-template let-activity="activity">
                <sc-activity-item [activity]="activity" [condensed]="false"
                    [showProjectName]="true"></sc-activity-item>
            </ng-template>
        </sc-activity-feed>
    </div>

    <div class="card-body card-body-list" *ngIf="obfuscate">

        <div class="list-group">
            <a class="list-group-item list-group-item-action" *ngFor="let a of demoActivities">

                <div class="row align-items-center">

                    <div class="col-auto">
                        <div class="activity-avatar">
                            <sc-avatar [user]="a" size="lg"></sc-avatar>
                            <span class="activity-icon bg-primary-lighter">
                                <fa class="{{ a.Icon }}"></fa>
                            </span>
                        </div>
                    </div>

                    <div class="col col-shrink">
                        <div class="mb-1">
                            <span class="fw-bold">{{ a.Headline }} {{ a.FirstName }} {{ a.LastName | slice : 0 : 1 }}.</span>
                            <span class="badge badge-pill bg-positive-lighter text-success ms-3" style="transform: translateY(.4rem);">{{ a.Topic }}</span>
                        </div>
                        <p class="small fw-normal mb-0">{{ a.Report }}</p>
                          <div class="small text-muted d-none d-md-block">{{ a.Date }}</div>
                    </div>

                    <div class="col-auto text-muted ps-0">
                        <i class="fa-regular fa-chevron-right"></i>
                    </div>

                </div>
            </a>
        </div>

    </div>
</div>
